import { useParams } from "react-router-dom";
import PublicProposalView from "@/components/proposals/PublicProposalView";

const ProposalHistoryPublicPreview = () => {
  const { id, revisionId } = useParams();

  return <PublicProposalView proposalId={id} revisionId={revisionId} />;
};

export default ProposalHistoryPublicPreview;
